import { useState, useEffect, useRef, useCallback } from 'react';
import { Dimensions, Animated } from 'react-native';
import { getLayoutConfig, isCloseToBottom, padDataWithEmptyItems } from '@components/productionOrders/helpers';

const ITEMS_PER_LOAD = 24;
const LOAD_MORE_COOLDOWN = 1000;

const useManageProductionOrders = ({ getData, loadNewData, productionOrders, navigation }) => {
  const [renderElements, changeRenderElements] = useState(ITEMS_PER_LOAD);
  const [alowLoadMore, setLoadMore] = useState(true);

  const fadeAnim = useRef(new Animated.Value(0)).current;
  const scrollRef = useRef(null);

  const devWidth = Dimensions.get('window').width;
  const devHeight = Dimensions.get('window').height;

  const fetchData = useCallback(async () => {
    await getData(navigation);
  }, [getData, navigation]);

  useEffect(() => {
    fetchData();
  }, []);

  const { itemSize, boxStyle, columns } = getLayoutConfig(devWidth, devHeight);

  const dataToRender = productionOrders?.data?.productionOrders
    ? JSON.parse(JSON.stringify(productionOrders.data.productionOrders))
    : [];
  const slicedData = dataToRender.slice(0, renderElements);
  const data = padDataWithEmptyItems(slicedData, columns);

  const scrollListener = useCallback(
    ({ nativeEvent }) => {
      if (isCloseToBottom(nativeEvent.layoutMeasurement, nativeEvent.contentOffset, nativeEvent.contentSize) && alowLoadMore) {
        setLoadMore(false);
        const amount = renderElements + ITEMS_PER_LOAD;
        changeRenderElements(amount);
        if (productionOrders?.data?.productionOrders && productionOrders.data.productionOrders.length - 20 < amount) {
          loadNewData();
        }
        setTimeout(() => {
          setLoadMore(true);
        }, LOAD_MORE_COOLDOWN);
      }
    },
    [alowLoadMore, renderElements, productionOrders, loadNewData],
  );

  const totalRecords = productionOrders?.pagination?.TotalRecords;
  const isError = productionOrders?.isError;
  const isLoaded = productionOrders?.loaded;
  const hasData = productionOrders?.data?.productionOrders?.length > 0;

  return {
    data,
    itemSize,
    boxStyle,
    fadeAnim,
    scrollRef,
    scrollListener,
    fetchData,
    totalRecords,
    isError,
    isLoaded,
    hasData,
  };
};

export default useManageProductionOrders;
